// ============================================================================
//  Validadores genéricos para steps de tipo "text".
//  Cada validador recibe el valor (ya .trim()) y devuelve:
//    - null  → si es válido
//    - string → mensaje de error a mostrar al usuario
//  Se enganchan en los steps con la propiedad `validate`. Un step sin
//  `validate` no valida nada (comportamiento anterior).
// ============================================================================

export const validarCedula = (v) => {
  const sinEspacios = v.replace(/\s/g, "");
  if (!/^\d+$/.test(sinEspacios)) return "La cédula debe contener solo números.";
  if (sinEspacios.length !== 8) return "La cédula debe tener 8 dígitos.";
  return null;
};

export const validarEmail = (v) => {
  const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  return ok ? null : "Ingresá un correo electrónico válido (ej: nombre@email.com).";
};

export const validarFecha = (v) => {
  const m = v.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!m) return "Ingresá la fecha en formato DD/MM/AAAA (ej: 15/06/2001).";
  const dia = +m[1], mes = +m[2], anio = +m[3];
  const d = new Date(anio, mes - 1, dia);
  const valida = d.getFullYear() === anio && d.getMonth() === mes - 1 && d.getDate() === dia;
  if (!valida) return "La fecha no es válida.";
  if (d > new Date()) return "La fecha no puede ser futura.";
  if (anio < 1900) return "Revisá el año de nacimiento.";
  return null;
};